import React from "react";
import styles from "./Pagination.module.css"; 
import { ArrowRight, ArrowLeft } from 'react-feather';

export default function Pagination({
  page,
  totalPages,
  pageSize,
  totalResults,
  onPageChange,
}) {
  const buildPages = () => {
    if (totalPages <= 5) return [...Array(totalPages).keys()].map((n) => n + 1);

    const pages = [1];
    const showRange = 2;

    let start = Math.max(2, page - showRange);
    let end   = Math.min(totalPages - 1, page + showRange);

    if (page <= 3) end = 5;
    if (page >= totalPages - 2) start = totalPages - 4;

    if (start > 2) pages.push("ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("ellipsis");

    pages.push(totalPages);
    return pages;
  };

  const pageList = buildPages();

  return (
    <div className={styles.wrapper}>
      <ul className={styles.pagination}>
        <li>
          <button
            className={`${styles.arrow} ${page === 1 ? styles.disabled : ""}`}
            onClick={page === 1 ? undefined : () => onPageChange(page - 1)}
            aria-label="Previous page"
          >
            <ArrowLeft width="16" height="16"/>
          </button>
        </li>

        {pageList.map((p, idx) =>
          p === "ellipsis" ? (
            <li key={`e${idx}`} className={styles.ellipsis}>…</li>
          ) : (
            <li key={p}>
              <button
                className={`${styles.pageBtn} ${p === page ? styles.active : ""}`}
                onClick={() => onPageChange(p)}
              >
                {p}
              </button>
            </li>
          )
        )}
        <li>
          <button
            className={`${styles.arrow} ${page === totalPages ? styles.disabled : ""}`}
            onClick={page === totalPages ? undefined : () => onPageChange(page + 1)}
            aria-label="Next page"
          >
            <ArrowRight width="16" height="16"/>
          </button>
        </li>
      </ul>
    </div>
  );
}